import {
  CIRCLE_ELEMENTS,
  CLASSES_FOCUSED,
  ID_NAME_PLAYER_CONTROL,
  ID_NAME_SECONDLEVEL,
  ID_NAME_SUPERDESTACADOS,
  ID_NAME_VCARD_OPTIONS,
  ID_NAME_LO_MAS_VISTO,
  ID_MODAL_FILTER_BUTTON,
  ID_NAME_SEASON_TEMP,
  ID_NAME_CANALES_PREMIUM,
  ID_NAME_CARD_VERTICAL,
  ID_NAME_CARD_CLASSIC,
  ID_NAME_CARD_INFINITE,
  ID_NAME_CARD_TOON_CHARACTER,
  ID_NAME_CARD_LANDSCAPE,
  STYLEFILTERBUTTON,
  COLORFILTERBUTTON,
  ID_NAME_VCARD_OPTIONS_YELLOW,
  ID_PROFILE_AVATAR_IMAGE,
  ID_NAME_OLD_CARD_PORTRAIT,
  ID_NAME_OLD_CARD_EPG_EVENT,
  ID_NAME_CARD_MODAL_EPISODE,
} from "./constants";
import store from "src/store";
import Metadata from "../../requests/apa/Metadata";
import {getDeviceCategory} from "./utils-to-devices/utils-device-category";
import {
  getExtraValuesConsole,
  getValuesWidthAndHeightConsole
} from "./utils-to-devices/utils-console";
import {
  getExtraValuesTv,
  getValuesWidthAndHeightTv
} from "./utils-to-devices/utils-tv";

const deviceCategory = getDeviceCategory();

import DeviceStorage from "../DeviceStorage/DeviceStorage";

export const getElements = (evt: HTMLElement) => {
  const imageContainer = evt.querySelector('.container-card-cover')
  const imageContainerAvatar = evt.id === ID_PROFILE_AVATAR_IMAGE ? evt.querySelector('img') : null;
  const image = imageContainer ? imageContainer.querySelector('img') : null;
  const coverImage = evt.querySelector('.card-cover');
  const mask = document.querySelector('.focus-container');
  const target = coverImage || image || imageContainerAvatar ||evt;
  const ribbonHighlight = evt.querySelector('.card-highlight');

  return {
    imageContainer,
    image,
    coverImage,
    mask,
    target,
    ribbonHighlight
  };
};

export const reviewActiveElement = () => {
  const result = Array.from(document.querySelectorAll(CLASSES_FOCUSED));
  let activeElement = false;
  for (let i = 0; i < result.length; i++) {
    if (result[i] === document.activeElement) {
      activeElement = true;
    }
  }
  return activeElement
}

export const getElementsCircle = () => {
  const ribbonCircle = Array.from(document.querySelectorAll(CIRCLE_ELEMENTS));
  let activeElement = reviewActiveElement();
  let activeElementCircle = false;

  for (let i = 0; i < ribbonCircle.length; i++) {
    if (ribbonCircle[i] === document.activeElement) {
      activeElementCircle = true;
    }
  }

  return {activeElement, activeElementCircle};
};

export const getValuesWidthAndHeight = (evt: HTMLElement, ribbonHighlight: HTMLElement, target: HTMLElement) => {
  if(deviceCategory === 'console') return getValuesWidthAndHeightConsole(evt, ribbonHighlight, target);
  else if(deviceCategory === 'tv') return getValuesWidthAndHeightTv(evt, ribbonHighlight, target);
  else return { widthElement: 0, heightElement: 0 };
}

export const getExtraValues = (evt: HTMLElement, direction: string) => {
  if(deviceCategory === 'console') return getExtraValuesConsole(evt, direction);
  else if(deviceCategory === 'tv') return getExtraValuesTv(evt, direction);
  else return {
      extraTop: 0,
      extraLeft: 0,
      timer: 0
    };
};

const getScaledValues = (evt: HTMLElement) => {
  const id= evt.id

  switch (true) {
    case id.includes(ID_NAME_VCARD_OPTIONS):
      return 'scale(1.1, 1.1)';
    case id.includes(ID_NAME_PLAYER_CONTROL):
      return "scale(1.15, 1.15)";
    default:
      return 'scale(1.03, 1.03)';
  }
}

export const setRedColorButton = (evt: any) => {
  if(evt && evt.id && evt.id.includes(STYLEFILTERBUTTON)){
    evt.style.backgroundColor = COLORFILTERBUTTON;
  }
};

export const transformMask = (
  mask: HTMLElement,
  validateElement: boolean,
  target: HTMLElement,
  extraTop: number,
  extraLeft: number,
  widthElement: number,
  heightElement: number,
  activeElementCircle: boolean,
) => {
  const {player: { isLive = false, playerstate = "STOPPING" }} = store.getState();
  const showPlayer = !isLive && playerstate === 'PLAYING' && target.id.includes(ID_NAME_VCARD_OPTIONS);
  mask.style.display = showPlayer ? 'none' : 'block';
  mask.style.top = `${target.getBoundingClientRect().top + extraTop}px`;
  mask.style.left = `${target.getBoundingClientRect().left + extraLeft}px`;
  mask.style.width = `${widthElement}px`;
  mask.style.height = `${heightElement}px`;
  mask.style.transform = getScaledValues(target);
  mask.style.borderRadius = activeElementCircle ? '50%' : '5px';
  mask.style.zIndex = '10000000000000';
  mask.style.border = validateElement ? '3px solid #FFFFFF' : 'transparent';
};


export const removeDynamicFocus = () => {
  const maskFocus = document.querySelector(".focus-container")
  if(maskFocus) maskFocus.style.display = "none";

}

export const isActiveFocusDynamic = () => {
  const region = DeviceStorage.getItem('region');
  const isEnable = Metadata.get('enable_foco', '{}');

  const getValueKey = JSON.parse(isEnable)
  const valueEnable = getValueKey[region] ? getValueKey[region].enable : (getValueKey["default"] ? getValueKey["default"].enable : false);

  return valueEnable;
}



// WEBPACK FOOTER //
// ./src/components/Focus/utils.ts